import { AppServices } from '@singularsystems/neo-core';
import DividendDocumentsApiClient from './ApiClients/DividendDocumentsApiClient';


// Symbols to expose outside of this module
export const DividendsSharedTypes = {
    ApiClients: {
        DividendDocumentApiClient: new AppServices.ServiceIdentifier<DividendDocumentsApiClient>("Dividends.ApiClients"),
    },
}